import {
  AddCoCap,
  FindTeamMember,
  PromoteCoCap,
  PromoteToCoCap,
  SendAnnouncementUpdate,
  ShareTeamAnnouncement,
  TeamLink,
} from '../../../../assets';
import { buildHashLink } from '../../../../utils';

const teamLink = `<a href="${buildHashLink('team')}"><u>Team</u></a>`;

const coCapContent = `
  <p title="">This feature is only available for team captains.</p>
  <ol title="">
    <li>
      <div>
        <p>Navigate to the&nbsp; ${teamLink} section of your fundraising center </p>
        <img src="${TeamLink}" alt="Team Link" />
      </div>
    </li>
    <li>
      <div>
        <p>Select the&nbsp; <strong>Promote a co-captain</strong> button from the menu below your team summary </p>
        <br />
        <img src="${PromoteCoCap}" alt="Promote Co Captain" />
      </div>
    </li>
    <li>
      <div>
        <p>Select the&nbsp; <strong>Add a co-captain</strong> button </p>
        <br />
        <img src="${AddCoCap}" alt="Add Co Captain" />
      </div>
      <ol type="a">
        <li>
          <em>Teams may have only one (1) captain and up to two (2) co-captains</em>
        </li>
      </ol>
    </li>
    <li>
      <div>
        <p>Search for the team member&rsquo;s name you&rsquo;d like to promote to co-captain.</p>
        <br />
        <img src="${FindTeamMember}" alt="Find Team Member" />
      </div>
    </li>
    <li>
      <div>
        <p>Select the team member you&rsquo;d like to promote from the search results and press the&nbsp; <strong>Promote to co-captain</strong> button </p>
        <br />
        <img src="${PromoteToCoCap}" alt="Promote to Co Captain" />
      </div>
    </li>
  </ol>
`;

const teamAnnouncementContent = `
  <p title="">This feature is only available for team captains.</p>
  <ol title="">
    <li>
      <div>
        <p>Navigate to the&nbsp; ${teamLink} section of your fundraising center </p>
        <img src="${TeamLink}" alt="Team Link Announcement" />
      </div>
    </li>
    <li>
      <div>
        <p>Select the&nbsp; <strong>Share a team-wide announcement</strong> button from the menu below your team summary </p>
        <br />
        <img src="${ShareTeamAnnouncement}" alt="Share Team Announcement" />
      </div>
    </li>
    <li>
      <div>
        <p>Enter the text you&rsquo;d like to share with your team and press the&nbsp; <strong>Send update</strong> button </p>
        <br />
        <img src="${SendAnnouncementUpdate}" alt="Send Announcement" />
      </div>
    </li>
  </ol>
`;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const managing_team = {
  id: 't',
  content: {
    articles: [
      {
        title: 'Promote a team member to co-captain',
        content: coCapContent,
      },
      {
        title: 'Publish a team announcement',
        content: teamAnnouncementContent,
      },
    ],
  },
};
